/**
 * @generated SignedSource<<3ef7acd0426711d726239bf8ab95a19c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type benefitLandingModalQuery$variables = {
  utmCampaign?: string | null | undefined;
  utmSource: string;
};
export type benefitLandingModalQuery$data = {
  readonly landingModal: {
    readonly active: boolean;
    readonly backgroundColor: string;
    readonly buttons: any | null | undefined;
    readonly endAt: any;
    readonly id: string;
    readonly imagePath: string;
    readonly manager: string | null | undefined;
    readonly name: string;
    readonly startAt: any;
    readonly userEvent: any | null | undefined;
    readonly utmCampaign: string | null | undefined;
    readonly utmSource: string | null | undefined;
  } | null | undefined;
};
export type benefitLandingModalQuery = {
  response: benefitLandingModalQuery$data;
  variables: benefitLandingModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmCampaign"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmSource"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "utmCampaign",
        "variableName": "utmCampaign"
      },
      {
        "kind": "Variable",
        "name": "utmSource",
        "variableName": "utmSource"
      }
    ],
    "concreteType": "LandingModalOutput",
    "kind": "LinkedField",
    "name": "landingModal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "manager",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "utmCampaign",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "utmSource",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imagePath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "backgroundColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userEvent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "buttons",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "benefitLandingModalQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "benefitLandingModalQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9e9bf823521512869b620f01137cca07",
    "id": null,
    "metadata": {},
    "name": "benefitLandingModalQuery",
    "operationKind": "query",
    "text": "query benefitLandingModalQuery(\n  $utmSource: String!\n  $utmCampaign: String\n) {\n  landingModal(utmSource: $utmSource, utmCampaign: $utmCampaign) {\n    id\n    name\n    manager\n    active\n    utmCampaign\n    utmSource\n    imagePath\n    backgroundColor\n    userEvent\n    buttons\n    startAt\n    endAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bcf9ee7b7a4b82348ea9b38c579f72f";

export default node;
